import React from "react";

const BlogsSchema = () => (
  <React.Fragment>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify([
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/6-offbeat-places-near-shimla-you-should-explore",
            },
            headline: "6 Offbeat Places Near Shimla You Should Explore",
            description:
              "Explore 6 offbeat places near Shimla, from peaceful villages to scenic mountain escapes, and discover a quieter side of Himachal beyond the usual tourist spots.",
            image:
              "https://www.adventureresortkufri.com/images/blogimages/6-offbeat/Offbeat-Places-Near-Shimla.png",
            author: {
              "@type": "Person",
              name: "Adventure Resorts Kufri",
              url: "https://www.adventureresortkufri.com",
            },
            publisher: {
              "@type": "Organization",
              name: "Adventure Resorts Kufri",
              logo: {
                "@type": "ImageObject",
                url: "https://www.adventureresortkufri.com/icons/adventure-icon.svg",
              },
            },
            datePublished: "2026-09-22",
            dateModified: "2026-09-22",
          },
          {
            "@context": "https://schema.org/",

            "@type": "BreadcrumbList",

            itemListElement: [
              {
                "@type": "ListItem",

                position: 1,

                name: "Adventure Resort Kufri",

                item: "https://www.adventureresortkufri.com",
              },
              {
                "@type": "ListItem",

                position: 2,

                name: "Blogs",

                item: "https://www.adventureresortkufri.com/blogs",
              },
              {
                "@type": "ListItem",

                position: 3,

                name: "6 Offbeat Places Near Shimla You Should Explore",

                item: "https://www.adventureresortkufri.com/blogs/6-offbeat-places-near-shimla-you-should-explore",
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/how-to-reach-adventure-resort-kufri-distance-routes-trav..",
            },
            headline:
              "How to Reach Adventure Resort Kufri: Distance, Routes, Travel Options & Tips",
            description:
              "Planning a trip to Adventure Resorts Kufri? Explore routes from Delhi, Chandigarh and Shimla, travel options, distances, road conditions and useful travel tips.",
            image:
              "https://www.adventureresortkufri.com/images/blogimages/reach-adventure/adventure-resort-kufri-image…",
            author: {
              "@type": "Person",
              name: "Adventure Resort Kufri",
              url: "https://www.adventureresortkufri.com/",
            },
            publisher: {
              "@type": "Organization",
              name: "Adventure Resort Kufri",
              logo: {
                "@type": "ImageObject",
                url: "https://www.adventureresortkufri.com/icons/adventure-icon.svg",
              },
            },
            datePublished: "2026-09-14",
            dateModified: "2026-09-14",
          },
          {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Adventure Resort Kufri",
                item: "https://www.adventureresortkufri.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blogs",
                item: "https://www.adventureresortkufri.com/blogs",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "How to Reach Adventure Resort Kufri: Distance, Routes, Travel Options & Tips",
                item: "https://www.adventureresortkufri.com/blogs/how-to-reach-adventure-resort-kufri-distance-routes-trav…",
              },
            ],
          },

          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/why-ananta-by-adventure-resort-is-ideal-for-corporate-meetings-events",
            },
            headline:
              "Why Ananta by Adventure Resort Is Ideal for Corporate Meetings & Events",
            description:
              "Host memorable corporate meetings and events in Kufri at Ananta by Adventure Resort, featuring spacious venues, AV facilities, stays and parking.",
            image:
              "https://www.adventureresortkufri.com/images/blogimages/corporate-meeting/corporate-meeting.png",
            author: {
              "@type": "Person",
              name: "Adventure Resorts Kufri",
              url: "https://www.adventureresortkufri.com/",
            },
            publisher: {
              "@type": "Organization",
              name: "Adventure Resorts Kufri",
              logo: {
                "@type": "ImageObject",
                url: "https://www.adventureresortkufri.com/icons/adventure-icon.svg",
              },
            },
            datePublished: "2026-09-05",
          },
          {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Adventure Resorts Kufri",
                item: "https://www.adventureresortkufri.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blogs",
                item: "https://www.adventureresortkufri.com/blogs",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Why Ananta by Adventure Resort Is Ideal for Corporate Meetings & Events",
                item: "https://www.adventureresortkufri.com/blogs/why-ananta-by-adventure-resort-is-ideal-for-corporate-meetings-events",
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/best-adventure-activities-in-kufri-complete-travel-guide",
            },
            headline:
              "Best Adventure Activities in Kufri: Complete Travel Guide",
            description:
              "Discover the best adventure activities in Kufri at Adventure Resort including skiing, trekking, and ziplining. Read the guide and plan your Kufri adventure today.",
            image: [
              "https://www.adventureresortkufri.com/images/blogimages/travel-guide/childrenPlay.png",
              "https://www.adventureresortkufri.com/images/blogimages/travel-guide/skiing.png",
            ],
            author: {
              "@type": "Organization",
              name: "Adventure Resort Kufri",
            },
            publisher: {
              "@type": "Organization",
              name: "Adventure Resort Kufri",
              logo: {
                "@type": "ImageObject",
                url: "https://www.adventureresortkufri.com/icons/logo.svg",
              },
            },
            datePublished: "2026-03-11",
          },
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/most-haunted-places-in-shimla",
            },
            headline: "Haunted Places in Shimla That Will Test Your Courage",
            description:
              "Planning a spooky trip? Discover haunted places in Shimla, real legends, safety tips, and a controlled haunted house experience in Kufri.",
            image:
              "https://www.adventureresortkufri.com/images/blogimages/haunted-places/haunted-women.png",
            author: {
              "@type": "Organization",
              name: "Adventure Resort",
            },
            publisher: {
              "@type": "Organization",
              name: "Adventure Resort Kufri",
              logo: {
                "@type": "ImageObject",
                url: "https://www.adventureresortkufri.com/icons/logo.svg",
              },
            },
            datePublished: "2026-04-14",
          },
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/best-summer-adventure-activities-in-shimla-for-an-unforgettable-trip",
            },
            headline: "Best Summer Adventure Activities in Shimla",
            description:
              "Discover the best adventure activities in Shimla this summer, from bungee ejection and trekking to paragliding and go-karting. Plan an unforgettable trip to Kufri.",
            image:
              "https://www.adventureresortkufri.com/images/blogimages/best-summer-activities/featured.png",
            author: {
              "@type": "Organization",
              name: "Adventure Resort Kufri",
            },
            publisher: {
              "@type": "Organization",
              name: "Adventure Resort Kufri",
              logo: {
                "@type": "ImageObject",
                url: "https://www.adventureresortkufri.com/icons/adventure-icon.svg",
              },
            },
            datePublished: "2026-05-14",
          },
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/jump-bounce-fly-the-ultimate-bungee-trampoline-experience",
            },
            headline:
              "Jump, Bounce, Fly: The Ultimate Bungee Trampoline Experience",
            description:
              "Experience the thrill of a Bungee Trampoline in Kufri. Jump higher, perform flips, and enjoy a safe adventure for kids, families, and thrill-seekers at Adventure Resort.",
            image:
              "https://www.adventureresortkufri.com/images/blogimages/jump-bounce/bungee_jump.png",
            author: {
              "@type": "Organization",
              name: "Adventure Resorts",
            },
            publisher: {
              "@type": "Organization",
              name: "Adventure Resorts",
              logo: {
                "@type": "ImageObject",
                url: "https://www.adventureresortkufri.com/icons/logo.svg",
              },
            },
            datePublished: "2026-06-03",
          },
          {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.adventureresortkufri.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blogs",
                item: "https://www.adventureresortkufri.com/blogs",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Jump, Bounce, Fly: The Ultimate Bungee Trampoline Experience",
                item: "https://www.adventureresortkufri.com/blogs/jump-bounce-fly-the-ultimate-bungee-trampoline-experience",
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/how-to-plan-a-destination-wedding-in-shimla",
            },
            headline: "How to Plan a Destination Wedding in Shimla",
            description:
              "Looking for a destination wedding in Shimla? Discover how to plan your dream wedding with best venue, budgeting, guest management, & luxury wedding experiences.",
            image:
              "https://www.adventureresortkufri.com/images/blogimages/destination-wedding/feature.png",
            author: {
              "@type": "Person",
              name: "Ananta by Adventure Resorts",
              url: "https://ananta.adventureresortkufri.com/wedding-venues-in-shimla",
            },
            publisher: {
              "@type": "Organization",
              name: "Ananta by Adventure Resorts",
              logo: {
                "@type": "ImageObject",
                url: "https://ananta.adventureresortkufri.com/icons/ananta-logo.svg",
              },
            },
            datePublished: "2026-07-01",
          },
          {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.adventureresortkufri.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blogs",
                item: "https://www.adventureresortkufri.com/blogs",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Destination Wedding in Shimla",
                item: "https://www.adventureresortkufri.com/blogs/how-to-plan-a-destination-wedding-in-shimla",
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/top-10-reasons-to-explore-shimla-in-monsoon",
            },
            headline: "Top 10 Reasons to Explore Shimla in Monsoon",
            description:
              "Planning a trip to Shimla in monsoon? Discover the best reasons to visit, travel tips, scenic attractions, and fun indoor activities near Shimla.",
            image:
              "https://www.adventureresortkufri.com/images/blogimages/top-10-monsoon/adventure-resort-inner-image.png",
            author: {
              "@type": "Person",
              name: "Adventure Resorts",
            },
            publisher: {
              "@type": "Organization",
              name: "Adventure Resorts Kufri",
              logo: {
                "@type": "ImageObject",
                url: "https://www.adventureresortkufri.com/icons/adventure-icon.svg",
              },
            },
            datePublished: "2026-07-28",
            dateModified: "2026-07-28",
          },
          {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Adventure Resort Kufri",
                item: "https://www.adventureresortkufri.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blogs",
                item: "https://www.adventureresortkufri.com/blogs",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Top 10 Reasons to Explore Shimla in Monsoon",
                item: "https://www.adventureresortkufri.com/blogs/top-10-reasons-to-explore-shimla-in-monsoon",
              },
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.adventureresortkufri.com/blogs/adventure-resorts-kufri-ticket-price-2026-online-booking",
            },
            headline: "Adventure Resorts Kufri Ticket Price 2026",
            description:
              "Explore Adventure Resorts Kufri 2026 packages with updated ticket prices, snow park, go karting, combo offers, timings and easy online booking details.",
            image:
              "https://www.adventureresortkufri.com/images/blogimages/offers-activities-2026/adventure-resorts-kufri-ticket-price-2026.webp",
            author: {
              "@type": "Organization",
              name: "Adventure Resorts Kufri",
              url: "https://www.adventureresortkufri.com",
            },
            publisher: {
              "@type": "Organization",
              name: "Adventure Resorts Kufri",
              logo: {
                "@type": "ImageObject",
                url: "https://www.adventureresortkufri.com/icons/adventure-icon.svg",
              },
            },
            datePublished: "2026-07-31",
            dateModified: "2026-07-31",
            url: "https://www.adventureresortkufri.com/blogs/adventure-resorts-kufri-ticket-price-2026-online-booking",
            inLanguage: "en",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.adventureresortkufri.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blogs",
                item: "https://www.adventureresortkufri.com/blogs",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Adventure Resorts Kufri Ticket Price 2026",
                item: "https://www.adventureresortkufri.com/blogs/adventure-resorts-kufri-ticket-price-2026-online-booking",
              },
            ],
          },
        ]),
      }}
    />
  </React.Fragment>
);

export default BlogsSchema;
